module.exports = __webpack_public_path__ + "img/home01.636d43ff.png";